import type { LobbyModuleKind } from "./api";

// The LSC default section eyebrow per module kind (LSC-258). A module's `label`
// overrides it; unset falls back here. Shared by the public renderer and the editor
// (which shows it as the field placeholder), so the default lives in one place.
export const KIND_EYEBROW: Record<LobbyModuleKind, string> = {
  story: "From the Cave",
  stats: "On the court",
  programming: "CaveCasts",
  linkedCards: "People · Projects · Possibilities",
  partners: "Partners",
  social: "Follow the Cave",
};
